import axios from 'axios';
import BaseUrl from '../../utils/api.js';


export default class CommandService {

    static getCommandPendind(CompanyCode, DeviceSerialNumber, email) {
        //var data = [];
        return axios.get(`${ BaseUrl }CommandPend?Companycode=${ CompanyCode }&DeviceSerialNumber=${ DeviceSerialNumber ? DeviceSerialNumber : "" }&email=${ email }`);
    }
    static getCommand(CompanyCode, DeviceSerialNumber, email) {
        //var data = [];
        return axios.get(`${ BaseUrl }Command?CompanyCode=${ CompanyCode }&DeviceSerialNumber=${ DeviceSerialNumber ? DeviceSerialNumber : "" }&email=${ email }`);
    }

    static DeleteCommandPending(id, CompanyCode, email) {
        //var id = serialNumber;
        return axios.delete(`${ BaseUrl }CommandPend?DeviceSerialNumber=${ id }&Companycode=${ CompanyCode }&email=${ email }`);
    }

    static AdjustSensors(data) {
        //var id = serialNumber;

        console.log('on service', data)
        return axios.post(BaseUrl + 'Command/AdjustSensors?email=' + data.Email, data);
        // return axios.delete(`${ BaseUrl }adjust-sensors?DeviceSerialNumber=${ id }&Companycode=${ CompanyCode}&Email=${email}&`);
    }

    static AddCommandPending(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, CompanyCode, email) {
        var data = {
            DeviceID: DeviceID,
            DeviceSerialNumber: DeviceSerialNumber,
            CommandType: CommandType,
            Pending: Pending,
            Result: Result,
            Settled: Settled,
            CompanyCode: CompanyCode
        };
        return axios.post(BaseUrl + 'CommandPend?email=' + email, data);
    }
    static AddCommandPendingUpdate(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, CompanyCode, VersionTypeResult, VersionNameResult, email) {
        var data = {
            DeviceID: DeviceID,
            DeviceSerialNumber: DeviceSerialNumber,
            CommandType: CommandType,
            Pending: Pending,
            Result: Result,
            Settled: Settled,
            VERSION_TYPE: VersionTypeResult,
            VERSION_NAME: VersionNameResult,
            CompanyCode: CompanyCode
        };
        return axios.post(BaseUrl + 'CommandPend?email=' + email, data);
    }

    static CleanCache(DeviceSerialNumber, CompanyCode, email) {

        return axios.post(BaseUrl + `CleanCache?DeviceSerialNumber=${ DeviceSerialNumber }&CompanyCode=${ CompanyCode }&email=${ email }`);
    }

    static CleanRestriction(DeviceSerialNumber, CompanyCode, email) {

        return axios.delete(BaseUrl + `CommandPendDetails?DeviceSerialNumber=${ DeviceSerialNumber }&CompanyCode=${ CompanyCode }&email=${ email }`);
    }

    //cant by pending
    static getCommandPendindByDevice(CompanyCode, DeviceSerialNumber, email) {
        //var data = [];
        return axios.get(`${ BaseUrl }CommandPendByDevice?CompanyCode=${ CompanyCode }&DeviceSerialNumber=${ DeviceSerialNumber ? DeviceSerialNumber : "" }&email=${ email }`);
    }

    static DeleteCommandPendingDevicebyCommandType(id, CompanyCode, CommandType, email) {
        //var id = serialNumber;
        return axios.delete(`${ BaseUrl }CommandPendByDevice?DeviceSerialNumber=${ id }&CompanyCode=${ CompanyCode }&CommandType=${ CommandType }&email=${ email }`);
    }
    //details pending
    static getCommandPendDetails(CompanyCode, DeviceSerialNumber, email) {
        //var data = [];
        return axios.get(`${ BaseUrl }CommandPendDetails?CompanyCode=${ CompanyCode }&DeviceSerialNumber=${ DeviceSerialNumber ? DeviceSerialNumber : "" }&email=${ email }`);
    }

    static DeleteRestriction(id, CompanyCode, email) {
        //var id = serialNumber;
        return axios.delete(`${ BaseUrl }CommandPendDetails?DeviceSerialNumber=${ id }&Companycode=${ CompanyCode }&email=${ email }`);
    }
    static AddCommandEnableDisableSync(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, PARAM1, PARAM2, CompanyCode, email) {
        var data = {
            DeviceID: DeviceID,
            DeviceSerialNumber: DeviceSerialNumber,
            CommandType: CommandType,
            Pending: Pending,
            Result: Result,
            Settled: Settled,
            Param1: PARAM1,
            Param2: PARAM2,
            CompanyCode: CompanyCode
        };
        return axios.post(BaseUrl + 'CommandPend?email=' + email, data);
    }
    static AddCommandCleanDB(DeviceID, DeviceSerialNumber, CommandType, Pending, Result, Settled, PARAM1, PARAM2, PARAM3, CompanyCode, email) {
        var data = {
            DeviceID: DeviceID,
            DeviceSerialNumber: DeviceSerialNumber,
            CommandType: CommandType,
            Pending: Pending,
            Result: Result,
            Settled: Settled,
            Param1: PARAM1,
            Param2: PARAM2,
            Param3: PARAM3,
            CompanyCode: CompanyCode
        };
        return axios.post(BaseUrl + 'CommandPend?email=' + email, data);
    }

}


// WEBPACK FOOTER //
// ./src/Services/Command/command.js